<template>
  <div class="frame-chrome d-flex flex-column fill-height">
    <div class="frame-side__head">
      <router-link to="/" class="frame-brand flex-grow-1"><b>GASPRE</b><span>intra</span></router-link>
      <button
        v-if="!mobile"
        class="frame-icon-btn"
        type="button"
        aria-label="Peida menüü"
        title="Peida menüü"
        @click="$emit('hide')"
      >
        <v-icon size="22">{{ location === 'right' ? 'mdi-dock-right' : 'mdi-dock-left' }}</v-icon>
      </button>
    </div>

    <nav class="frame-side__nav" aria-label="Peamenüü">
      <template v-for="(item, index) in items" :key="item.text">
        <div v-if="item.section === 'admin' && (index === 0 || items[index - 1].section !== 'admin')" class="frame-side__rule" />
        <template v-if="item.children">
          <button
            class="frame-item"
            type="button"
            :aria-expanded="String(isOpen(item))"
            @click="toggle(item)"
          >
            <v-icon size="20">{{ item.icon }}</v-icon>
            <span class="frame-item__text">{{ item.text }}</span>
            <v-icon size="18" class="frame-chev" :class="{ 'is-open': isOpen(item) }">mdi-chevron-right</v-icon>
          </button>
          <template v-if="isOpen(item)">
            <template v-for="(child, i) in item.children" :key="i">
              <!-- A group inside the group: its name, its pages indented under it. -->
              <template v-if="child.children">
                <span class="frame-sub frame-sub__label">{{ child.text }}</span>
                <router-link
                  v-for="(grand, j) in child.children"
                  :key="j"
                  :to="grand.link"
                  class="frame-sub frame-sub--nested"
                  :class="{ 'is-on': isOn(grand.link) }"
                  @click="$emit('navigate')"
                >{{ grand.text }}</router-link>
              </template>
              <router-link
                v-else
                :to="child.link"
                class="frame-sub"
                :class="{ 'is-on': isOn(child.link) }"
                @click="$emit('navigate')"
              >{{ child.text }}</router-link>
            </template>
          </template>
        </template>
        <!-- href leaves this SPA (the akt module has its own router at /akt). -->
        <a v-else-if="item.href" :href="item.href" class="frame-item">
          <v-icon size="20">{{ item.icon }}</v-icon>
          <span class="frame-item__text">{{ item.text }}</span>
          <span v-if="item.badge" class="frame-badge" :title="item.badgeTitle">{{ item.badge }}</span>
        </a>
        <router-link
          v-else
          :to="item.link"
          class="frame-item"
          :class="{ 'is-on': isOn(item.link) }"
          :aria-current="isOn(item.link) ? 'page' : undefined"
          @click="$emit('navigate')"
        >
          <v-icon size="20">{{ item.icon }}</v-icon>
          <span class="frame-item__text">{{ item.text }}</span>
        </router-link>
      </template>
    </nav>

    <profile-menu :location="location === 'right' ? 'top end' : 'top start'" :mobile="mobile">
      <template #activator="{ props, open, initials, fullName, role }">
        <button class="frame-me" type="button" aria-haspopup="dialog" v-bind="props">
          <span class="frame-avatar" aria-hidden="true">{{ initials }}</span>
          <span class="frame-me__text">
            <span class="frame-me__name">{{ fullName }}</span>
            <span class="frame-me__role">{{ role }}</span>
          </span>
          <v-icon size="18">{{ open ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
        </button>
      </template>
    </profile-menu>
  </div>
</template>

<script>
import ProfileMenu from './ProfileMenu.vue'
import frameLinks from './frameLinks'

export default {
  components: { ProfileMenu },
  mixins: [ frameLinks ],
  props: {
    items: { type: Array, required: true },
    location: { type: String, default: 'left' },
    mobile: { type: Boolean, default: false }
  },
  emits: ['hide', 'navigate'],
  data () {
    return {
      // Groups the reader opened or closed by hand, by name. The group of the
      // current page is open unless they closed it.
      toggled: {}
    }
  },
  watch: {
    // A new page starts from the route again, as MainMenu does.
    '$route.path' () {
      this.toggled = {}
    }
  },
  methods: {
    isOpen (item) {
      return item.text in this.toggled ? this.toggled[item.text] : this.groupOn(item)
    },
    toggle (item) {
      this.toggled = { ...this.toggled, [item.text]: !this.isOpen(item) }
    }
  }
}
</script>
